import { Component, Input, computed, inject, input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { BetContextualDataService } from 'packages/sports/common/betslip/modules/betplacement/services/request/bet-contextual-data.service';

import { MyBetsBet, MyBetsBetSlip, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsTextBadgeModel } from '../badges/my-bets-text-badge.component';

@Component({
    selector: 'ms-my-bets-single-bet-card',
    templateUrl: 'my-bets-single-bet-card.html',
    standalone: false,
})
export class MyBetsSingleBetCardComponent {
    @Input({ required: true }) betslip: MyBetsBetSlip;
    @Input() myBetsListContext: MyBetsListContext;
    mybetsTextBadgeModel = MyBetsTextBadgeModel;
    isEpMarket = true;
    cashedOut = input(false);
    cancelledBet = input(false);

    private bcdService = inject(BetContextualDataService);
    private bcdSignal = this.bcdService.betContextualDataSignal;

    showTwoUpMarketSignText = computed(
        () =>
            this.bcdSignal()
                ?.get(this.betslip.betslipId)
                ?.some((ep) => ep.optionId === this.bet.optionMarketInfo?.optionId) &&
            !this.cancelledBet() &&
            !this.cashedOut(),
    );

    constructor(public sitecore: Sitecore) {}

    get bet(): MyBetsBet {
        return this.betslip.bets[0];
    }

    get isCashoutMessageVisible(): boolean {
        return this.betslip.isRecoveringAfterEditBet;
    }
}
